var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeusDadosWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7273 21H1.90909C1.66799 21 1.43675 20.9042 1.26627 20.7337C1.09578 20.5632 1 20.332 1 20.0909V1.90909C1 1.66799 1.09578 1.43675 1.26627 1.26627C1.43675 1.09578 1.66799 1 1.90909 1H17.8182",
    stroke: "#F8F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18164 13.0449H11.4407",
    stroke: "#F8F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18164 16.7578H10.3525",
    stroke: "#F8F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53073 4.25586H4.18164V9.14859H8.53073V4.25586Z",
    stroke: "#F8F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8184 9.63672C19.1991 9.63672 20.3184 8.51743 20.3184 7.13672C20.3184 5.75601 19.1991 4.63672 17.8184 4.63672C16.4376 4.63672 15.3184 5.75601 15.3184 7.13672C15.3184 8.51743 16.4376 9.63672 17.8184 9.63672Z",
    stroke: "#F8F7F7",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 13.7267C21.0004 12.8829 20.6651 12.0736 20.0684 11.4769C19.4717 10.8801 18.6624 10.5449 17.8185 10.5449C16.9747 10.5449 16.1654 10.8801 15.5687 11.4769C14.9719 12.0736 14.6367 12.8829 14.6367 13.7267V16.454H16.0758L16.4549 20.9995H19.1822L19.5613 16.454H21.0004V13.7267Z",
    stroke: "#F8F7F7",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeusDadosWhiteIcon);
export default __webpack_public_path__ + "static/media/meus-dados-white-icon.317aa0e9553ecf07dc73acded0a3fd98.svg";
export { ForwardRef as ReactComponent };